export default "__VITE_ASSET__B_wR_8L$__"